import React, { Component } from 'react';
import intl from "react-intl-universal";
import V_Data_Proccessing from "../../img/DataProcessing.png";

class newPMProjectPhaseIV extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ marginTop: "80px" }}>
                <img className="UploadingImages" src={V_Data_Proccessing} />
                </div>
                <div style={{ marginTop: "40px", textAlign: 'center', color: '#3185c0', fontFamily: 'Ubuntu, Medium', fontSize: '18px' }}>
                    <h4 className="moreSpacefromTitleToTable">
                        {this.props.skipSteps ? 
                            intl.get("PM_Cloud_PhaseIV_Skip_Data_Processing_Title")
                        :
                            intl.get("PM_Cloud_PhaseIV_Data_Processing_Title")
                        }
                    </h4>
                </div>
                
                <div style={{ marginTop: "40px", textAlign: 'center' }}>
                    {this.props.isSubLoginType ? 
                    <h4 style={{fontSize: '18px', display: 'inline-flex', width: '56%'}}>
                        {intl.get("PM_Cloud_PhaseIV_Data_Processing_Description")}
                    </h4> 
                    : 
                    <h4 style={{fontSize: '18px', display: 'inline-flex', width: '63%'}}>
                        {intl.get("PM_Cloud_PhaseIV_Data_Processing_Description")}{intl.get("PM_Cloud_PhaseIV_Data_Processing_Description_Part_2")}
                    </h4>
                    }
                    {this.props.isSubLoginType ? 
                    "" 
                    : 
                    <p style={{marginTop: '40px'}}>{intl.getHTML("PM_Cloud_PhaseIV_Uploading_Completed_Successfuly", {accountPage: "\\store\\account?isCloudProcessing=true"})}</p>}
                </div>
            </React.Fragment>
        );
    }
}

export default newPMProjectPhaseIV;